export default import.meta.ROLLUP_FILE_URL_D82$p6M3SE2wsToUVGEfeg